import channelService from "src/utils/channelService";

export default function ChannelIo() {
  channelService.loadScript();
  channelService.boot({
    pluginKey: `${process.env.REACT_APP_CHANNEL_IO_ID}`,
  });
}
